<template>
  <li>
    <div class="row">
      <div class="col-6 col-md-2">
        <span class="data-label d-md-none">Date</span>
        {{ log.date }}
      </div>
      <div class="col-6 col-md-1">
        <span class="data-label d-md-none">Time</span>
        {{ log.time }}
      </div>
      <div class="col-6 col-md-4">
        <p class="text-truncate">
          <span class="data-label d-md-none">User</span>
          {{ log.user && log.user.name }}
        </p>
      </div>
      <div class="col-6 col-md-4">
        <p class="text-truncate">
          <span class="data-label d-md-none">Action</span>
          {{ actionName(log.action) }}
        </p>
      </div>
    </div>
    <!-- /.row -->

    <div class="collapse" :id="`log-details-${log.id}`">
      <small class="text-muted d-block">{{ log.ip ? `IP: ${log.ip}` : '' }}</small>

      <code>
        {{ log.content }}
      </code>
    </div>
    <!-- /.collapse -->

    <button
      type="button"
      class="btn btn-sm"
      data-toggle="collapse"
      :data-target="`#log-details-${log.id}`"
      aria-expanded="false"
      :aria-controls="`#log-details-${log.id}`"
    >
      <i class="fa fa-plus"></i>
    </button>
  </li>
</template>

<script>
import { get } from 'lodash'

export default {
  props: {
    log: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  methods: {
    actionName (action) {
      return get({
        created: 'Created',
        updated: 'Updated'
      }, action, action)
    }
  }
}
</script>
